// Multisucursal — visibilidad de pedidos entrantes (F1).
//
// En una cuenta multi-sucursal TODOS los pedidos —incluido el de la sucursal propia— llegan por el
// canal de cuenta `panel_<accountId>`; el frontend los distingue con `isCurrentCommerce`. La regla
// de negocio: un usuario sin permiso multisucursal (no root o sin el módulo PEDIDOS_MULTISUCURSAL)
// NO debe ver/oír/imprimir pedidos de OTRAS sucursales, pero SÍ los suyos.
//
// Esta función es la lógica pura del gate (extraída de useIncomingOrder para poder testearla y para
// NO reintroducir el incidente #1004: los pedidos propios nunca dependen del permiso).
//
// - isCurrentCommerce: `true` si el pedido es de la sucursal activa (o sin commerceId);
//   `false`/`undefined` si es de otra sucursal.
// - canSeeOtherBranchOrders: `isRoot && hasModule(PEDIDOS_MULTISUCURSAL)`.
// - retorna `true` si el pedido debe ignorarse por completo (sin Kanban, toast, alarma ni impresión).
export const shouldIgnoreIncomingOrder = (
  isCurrentCommerce: boolean | undefined,
  canSeeOtherBranchOrders: boolean,
): boolean => {
  return !isCurrentCommerce && !canSeeOtherBranchOrders;
};

// Multisucursal — impresión automática de pedidos entrantes.
//
// La impresora es física: vive en UNA sucursal. Por eso la impresión automática debe ocurrir SOLO
// para pedidos de la sucursal activa, INDEPENDIENTEMENTE del permiso multisucursal. Un usuario root
// con el módulo PEDIDOS_MULTISUCURSAL SÍ ve/oye pedidos de otras sucursales (no se silencian), pero
// su impresora NO debe imprimir tickets de otras sucursales (causa del reporte "se imprimían todas
// las sucursales"). El `onOrderAccepted` al aceptar manualmente ya está acotado a la sucursal actual.
//
// - isCurrentCommerce: `true` si el pedido es de la sucursal activa (o sin commerceId).
// - hasAutoPrintModule: `hasModule('IMPRESION_AUTOMATICA') === true`.
// - retorna `true` solo si debe imprimirse automáticamente.
export const shouldAutoPrintIncomingOrder = (
  isCurrentCommerce: boolean | undefined,
  hasAutoPrintModule: boolean,
): boolean => {
  return isCurrentCommerce === true && hasAutoPrintModule;
};

export default shouldIgnoreIncomingOrder;
